import { useStandardOperatingProcedure } from '../hooks/useStandardOperatingProcedure'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Alert, Modal } from '@hivewatch/dark'

import { selectSOP } from '@/redux/ui/uiSlice'

import { SOPDocument } from './SOPDocument'

interface SOPModalIProps {
  isOpen: boolean
  onClose: () => void
}

export const SOPModal = ({ isOpen, onClose }: SOPModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { id } = useSelector(selectSOP)
  const { data, isLoading, error } = useStandardOperatingProcedure({ id })

  if (error) {
    return (
      <Modal
        colorScheme={colorScheme}
        isOpen={isOpen}
        isSaveHidden
        onClose={onClose}
        size='compact'
        title={t('sops:drawer_sop_document_title')}
      >
        <Alert
          colorScheme={colorScheme}
          description={t('sops:drawer_error_message')}
          variant='error'
        />
      </Modal>
    )
  }

  return (
    <Modal
      bodyStyleOverrides={{ overflow: 'hidden', p: 0 }}
      colorScheme={colorScheme}
      containerStyleOverrides={{ h: '92vh', maxH: '92vh' }}
      isOpen={isOpen}
      isSaveHidden
      maxW='95vw'
      onClose={onClose}
      title={
        isLoading
          ? t('sops:drawer_loading_sop')
          : data?.name || t('sops:drawer_untitled_sop')
      }
    >
      <SOPDocument colorScheme={colorScheme} isLoading={isLoading} sop={data} />
    </Modal>
  )
}
